import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

// @mui
import List from '@mui/material/List'
import { Divider, ListItem, ListItemText, Box, ListItemButton, Collapse } from '@mui/material'

import IconButton from '@mui/material/IconButton'
// components
import Iconify from 'src/components/iconify'
import { useState } from 'react'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import Scrollbar from '../scrollbar'



export default function NotificationReport({ values, setOpenModal, setOpenDrawer }) {

  const [open, setOpenIndex] = useState(false)

  const handleClick = (index) => {
    setOpenIndex(open === index ? null : index)
  }

  const list = () =>
    values.length && (
      <div style={{ height: '300px' }}>
        <Scrollbar>
          <List>
            {values.map((elem, index) => (
              <div key={index}>
                <ListItemButton 
                  onClick={elem.description ? () => handleClick(index) : null}
                  sx={{
                    '&:hover': { backgroundColor: 'action.hover' },
                    borderRadius: 1,
                    color: 'white',
                  }}
                >
                  <ListItemText primary={elem.name} />
                  {elem.path && (
                    <IconButton
                      onClick={() => {
                        setOpenModal(false)
                        setOpenDrawer(false)
                        console.log("elem-icon", elem)
                      }}
                      component={NavLink}
                      to={window.appConfig.appPrefix + elem.path}
                      sx={{ color: elem.iconColor || 'default' }}
                    >
                      <Iconify icon={`solar:${elem.icon}`} />
                    </IconButton>
                  )}
                  {elem.description && (open === index? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>
                <Collapse in={open === index} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItem 
                    sx={{ 
                      pl: 4
                    }}>
                      <ListItemText primary={elem.description} 
                      sx={{ 
                        p:2,
                        backgroundColor: 'action.hover',
                        borderRadius: 1,
                        color: 'white',
                      }}/>
                    </ListItem>
                  </List>
                </Collapse>

                <Divider />
              </div>
            ))}
          </List>
        </Scrollbar>
      </div>
    )

  return <Box sx={{ width: '100%', bgcolor: 'background.paper', overflow: 'auto' }}>{list()}</Box>
}

NotificationReport.propTypes = {
  values: PropTypes.array,
  setOpenModal: PropTypes.func,
  setOpenDrawer: PropTypes.func,
}
